module.exports = __webpack_public_path__ + "static/img/header_moren.ebbf50db.png";